import { render, staticRenderFns } from "./CopyContentLazy.vue?vue&type=template&id=5e050b5a&"
import script from "./CopyContentLazy.vue?vue&type=script&lang=js&"
export * from "./CopyContentLazy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports